var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIt = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 12,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F5F8FB",
  d: "M0 0h16v12H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#258B1E",
  d: "M0 0h5v12H0z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#E51D1D",
  d: "M11 0h5v12h-5z"
})));
export default SvgIt;